export default __webpack_public_path__ + "static/media/mince_konfety.b17b01e3.png";